module.exports = __webpack_public_path__ + "img/landkreis_altoetting.a0cb864.png";